module.exports = __webpack_public_path__ + "static/img/02.1758dfe3.png";